import posthog from 'posthog-js';

// Initialize PostHog
posthog.init('phc_rmymlJYeDMF5GIzlZ1v8Uf6DvClv8XvwvwJsdianodG', {
    api_host: 'https://us.i.posthog.com',
    person_profiles: 'identified_only'
});

export default posthog; 